import type { FC } from "react"
import { Link } from "@tanstack/react-router"
import { IconCreditCardOutline18 as CreditCard } from "nucleo-ui-outline-18"

import { cn } from "@productlane/lib/src/browser"

import type { PaymentIssue } from "@/lib/useTrial"
import { paymentIssueCopy } from "@/lib/payment-issue"

interface PaymentFailedBannerProps {
	issue: PaymentIssue
}

export const PaymentFailedBanner: FC<PaymentFailedBannerProps> = ({
	issue,
}) => {
	const { short } = paymentIssueCopy(issue)

	return (
		<div className="w-full px-2">
			<Link
				to="/settings/plans"
				className="group relative mb-2 mt-0 flex w-full select-none items-center justify-between rounded-lg bg-white px-3 py-2 shadow-sm ring-1 ring-black/5 hover:ring-black/15 dark:bg-gray-900 dark:shadow-black dark:ring-white/10 dark:hover:bg-gray-800"
			>
				<span className="text-sm">{short}</span>
				<CreditCard
					className={cn(
						"h-4 w-4 flex-none",
						issue.status === "unpaid"
							? "text-red-600 dark:text-red-400"
							: "text-yellow-600 dark:text-yellow-400",
					)}
					strokeWidth={1}
				/>
			</Link>
		</div>
	)
}
